import useSWR from 'swr';
import type { AxiosError } from 'axios';
import axios from 'axios';
import type ILabelEnumPair from '../../components/global/GlobalInterfaces';

const GetDepartments = () :
{ departments: ILabelEnumPair[] | undefined,
  isLoading: boolean,
  isError: boolean, } => {
  const fetcher = (url: string) => axios.get<ILabelEnumPair[]>(url)
    .then((response) => response.data);

  const { data, error } = useSWR<ILabelEnumPair[], AxiosError>('/employeeInfo/getDepartments',
    (url) => fetcher(url));

  return {
    departments: data,
    isLoading: !error && !data,
    isError: Boolean(error),
  };
};

export default GetDepartments;
